















































































































import {Component, Prop, Ref, Vue, Watch} from "vue-property-decorator";
import {SelectWings} from "wings-ui-components";
import {Action, Getter} from 'vuex-class';
import {notifyError, notifyErrorCustom} from '@/utils/notify-helper';
import {cloneDeep} from "lodash";
import i18n from "@/plugins/i18n";
import {getTranslatedParams} from "@/utils/notify-utils";
import {ActionLog} from "@/store/auth/types";

@Component({components: {SelectWings}})
export default class RegexRowItem extends Vue {

  @Action("saveRegexes") actionSaveItem: any;
  @Action("actionLog") actionLog: any;

  @Getter("allowedTransports") allowedTransportsList: any;
  @Getter("transports") transportsList: any;
  @Getter("messageCategories") messageCategoriesList: any;

  @Prop() regexRules: any;
  @Prop() serviceProviderItem: any;
  @Prop() isOpen!: any;
  @Prop() uniqueItem: any;

  @Ref("validator") validator: any;

  private onEdit: boolean = this.isOpen;
  private regexRule: any = [];
  private logObject: ActionLog = {};

  created() {
    this.regexRule = cloneDeep(this.regexRules);
  }

  onSaveItem(): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      this.$emit('onCheckUnique',this.regexRule);
      let valid: boolean = await this.validator.validate();
      if (valid) {
        if (this.uniqueItem){
          try {
            this.logObject = {
              action_page: this.$route.meta.msgKey,
              action: this.regexRule.id ? "Editing" : "Creation",
              action_status: "success",
              object_type: "Regular expression",
              addititional_info: getTranslatedParams(this.regexRule),
            }
            this.regexRule.service_provider_id = this.serviceProviderItem.id;
            await this.actionSaveItem(this.regexRule);
            await this.actionLog(this.logObject);
            resolve();
            this.onEdit = !this.onEdit;
            this.$emit('onSaveAction', true)
          } catch (error) {
            this.actionLog({...this.logObject, action_status: "failed"});
            reject();
            notifyError(error);
          }
        }
        else {
          notifyErrorCustom(i18n.tc('errors.violation'));
        }
      } else {
        setTimeout(() => {
          notifyError(null, this.validator.errors)
        }, 100);
      }
    })
  }

  getServiceProviderName(id: any) {
    return this.messageCategoriesList.find((obj: any) => obj.id === id)?.name
  }

  getTransportName(transport_id: any): any {
    if (this.transportsList) {
      return this.transportsList.find((t: any) => t.id === transport_id)?.name;
    }
  }

  get getAllowedTransportsList() {
    return this.allowedTransportsList.filter((transport_id: number) => {
      return this.serviceProviderItem.transport_names.includes(this.getTransportName(transport_id))
    })
  }

  allowedTransport(transport_id: number): boolean {
    let transport: string = this.getTransportName(transport_id);
    return this.serviceProviderItem.transport_names.includes(transport)
  }

  messageCategoryByTransport(transport_id: any, option: any): boolean {
    if (transport_id) {
      let item: any = cloneDeep(Object.assign({}, option));
      return item.transports.some((t: any) => t.transport_id === transport_id && t.is_default === 0);
    } else return false
  }

  onDeleteAction(): void {
    this.$emit('onDeleteAction', {regexRule: this.regexRule, key: this.$vnode.key})
  }

  onChangeTransport(): void {
    this.regexRule.message_category_id = null
  }



  @Watch('regexRules', {immediate: true, deep: true})
  onChange(val: any) {
    this.regexRule = cloneDeep(val);
  }
};
